var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import FormInputLarge from '@marketing/components/funnel/FormFields/FormInputLarge';
import { useNavigate } from 'react-router';
import { useProfileContext } from '../ProfileContext';
var PetNameInput = function (_a) {
    var petName = _a.petName, handlePetNameChange = _a.handlePetNameChange, validatePetName = _a.validatePetName, _b = _a.label, label = _b === void 0 ? 'What is your dog’s name?' : _b;
    var navigate = useNavigate();
    var _c = useProfileContext(), currentPetIndex = _c.currentPetIndex, pets = _c.profileData.pets, serverLoading = _c.serverLoading, removePet = _c.removePet, profileBasePath = _c.profileBasePath;
    var handleRemovePet = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    e.preventDefault();
                    return [4 /*yield*/, removePet(currentPetIndex)];
                case 1:
                    _a.sent();
                    navigate(profileBasePath, { viewTransition: true });
                    return [2 /*return*/];
            }
        });
    }); };
    return (_jsxs("div", { children: [_jsx(FormInputLarge, { defaultValue: petName, disabled: serverLoading, label: label, id: "pet-name", maxLength: 25, onInputChange: handlePetNameChange, placeholder: "Name", required: true, type: "text", validate: validatePetName }), pets.length > 1 && (_jsx("div", { children: _jsxs("button", __assign({ type: "button", className: "text-shoe underline font-medium text-sm-med-m md:text-sm-med-d px-8 py-4 md:py-5", onClick: handleRemovePet }, { children: ["Or remove ", petName] })) }))] }));
};
export default PetNameInput;
